export const FOOTER_MENU = {
  CHANNELS: 'Channels',
  ABOUT_US: 'About Us',
  HELP_CENTER: 'Help Center',
  PRIVACY_POLICY: 'Privacy Policy',
  TERMS_OF_USE: 'Terms of Use',
  BLOG: 'Blog',
  CONSENT_SETTINGS: 'Consent Settings',
  PREFERENCES: 'Preferences'
};

// STORE AND SOCIAL LINKS
export const FOOTER_STORE_SOCIAL_LINKS = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.graymatrix.did',
  IOS: 'https://apps.apple.com/in/app/zee5-shows-live-tv-movies/id743691886',
  FACEBOOK: 'https://www.facebook.com/ZEE5/',
  TWITTER: 'https://twitter.com/zee5india',
  INSTAGRAM: 'https://www.instagram.com/zee5/',
  YOUTUBE: 'https://www.youtube.com/channel/UCXOgAl4w-FQero1ERbGHpXQ'
};

// STORE AND SOCIAL LINKS FOR GLOBAL
export const FOOTER_STORE_SOCIAL_LINKS_GLOBAL = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.graymatrix.did',
  IOS: 'https://apps.apple.com/us/app/zee5-shows-live-tv-movies/id743691886',
  FACEBOOK: 'https://www.facebook.com/ZEE5USA/',
  TWITTER: 'https://twitter.com/ZEE5USA',
  INSTAGRAM: 'https://www.instagram.com/zee5.usa/',
  YOUTUBE: 'https://www.youtube.com/channel/UCXOgAl4w-FQero1ERbGHpXQ'
};

export const DOWNLOAD_APPS = 'Download Apps';
export const CONNECT_WITH_US = 'Connect with us';
export const BEST_VIEWED_ON =
  'Best viewed on Google Chrome 80+ , Safari 5.1.5+';

//APP STORE ICONS LINKS
export enum AppStoreLinks {
  PLAY_STORE = '/webapp-assets/images/play_store.png',
  APP_STORE = '/webapp-assets/images/app_store.png'
}
export enum AppStoreAlt {
  PLAY_STORE = 'Google Play',
  APP_STORE = 'App Store'
}
export const COPYRIGHT_TEXT =
  'Copyright © 2023 Zee Entertainment Enterprises Ltd. All rights reserved.';
